/** F7 — relatórios de gestão: cumprimento de prazos, guias, horas e exportação. */
import { z } from 'zod';
import { DataISO, Id } from './comum.js';
import { TarefaStatus } from './enums.js';

export const AgruparPor = z.enum(['cliente', 'responsavel', 'departamento', 'obrigacao']);
export type AgruparPor = z.infer<typeof AgruparPor>;

export const PeriodoQuery = z.object({ de: DataISO, ate: DataISO });

export const CumprimentoQuery = PeriodoQuery.extend({ agruparPor: AgruparPor.default('cliente'), departamento: z.string().trim().max(8).optional(), formato: z.enum(['json', 'csv', 'pdf']).default('json') });
export type CumprimentoQuery = z.infer<typeof CumprimentoQuery>;

export const CumprimentoGrupo = z.object({
  chave: z.string(), nome: z.string(), total: z.number().int(), concluidas: z.number().int(), noPrazo: z.number().int(), comAtraso: z.number().int(),
  dispensadas: z.number().int(), abertas: z.number().int(), atrasadasHoje: z.number().int(), pctNoPrazo: z.number().nullable(), mediaDiasAtraso: z.number().nullable(),
});
export type CumprimentoGrupo = z.infer<typeof CumprimentoGrupo>;
export const CumprimentoResposta = z.object({ periodo: PeriodoQuery, agruparPor: AgruparPor, grupos: z.array(CumprimentoGrupo), totais: CumprimentoGrupo });
export type CumprimentoResposta = z.infer<typeof CumprimentoResposta>;

export const GuiasQuery = PeriodoQuery.extend({ situacao: z.enum(['todas', 'abertas', 'pagas', 'vencidas']).default('todas'), formato: z.enum(['json', 'csv', 'pdf']).default('json') });
export type GuiasQuery = z.infer<typeof GuiasQuery>;
export const GuiaLinha = z.object({
  entregaId: Id, tarefaId: Id, clienteId: Id.nullable(), clienteNome: z.string().nullable(), obrigacaoSigla: z.string().nullable(), titulo: z.string(), competenciaLabel: z.string().nullable(),
  codigoReceita: z.string().nullable(), valorTotal: z.number(), vencimentoGuia: DataISO, dataPagamento: DataISO.nullable(), diasAtrasoPagamento: z.number().int().nullable(),
  responsavelApelido: z.string().nullable(), statusTarefa: TarefaStatus,
  /** nome da guia como o cliente vê e o "pagar até" quando houver */
  nomeGuia: z.string().optional(), pagarAte: DataISO.nullable().optional(),
});
export type GuiaLinha = z.infer<typeof GuiaLinha>;
export const GuiasResposta = z.object({
  periodo: PeriodoQuery, itens: z.array(GuiaLinha),
  totais: z.object({ quantidade: z.number().int(), valorTotal: z.number(), abertas: z.number().int(), valorAberto: z.number(), vencidas: z.number().int(), valorVencido: z.number(), pagas: z.number().int(), valorPago: z.number() }),
});
export type GuiasResposta = z.infer<typeof GuiasResposta>;

export const HorasQuery = PeriodoQuery.extend({ agruparPor: z.enum(['membro', 'cliente', 'obrigacao', 'departamento']).default('membro'), formato: z.enum(['json', 'csv', 'pdf']).default('json') });
export type HorasQuery = z.infer<typeof HorasQuery>;
export const HorasGrupo = z.object({ chave: z.string(), nome: z.string(), minutos: z.number().int(), apontamentos: z.number().int(), tarefas: z.number().int(), pct: z.number() });
export const HorasResposta = z.object({ periodo: PeriodoQuery, agruparPor: HorasQuery.shape.agruparPor, grupos: z.array(HorasGrupo), totalMinutos: z.number().int() });
export type HorasResposta = z.infer<typeof HorasResposta>;
